module.exports = __webpack_public_path__ + "media/images/baremetrics-20dde9725811473b83b02091ac9b49a7.svg";